export default import.meta.ROLLDOWN_FILE_URL_a9fATRz$rB7_JkAe8twOGA